import React, { useEffect, useState } from "react";
import Style from "../../style/eventlanding.module.scss";
import Img from "../../img/55.avif";
import { useParams } from "react-router-dom";
import EventLandingRight from "./EventLandingRight";

const EventLanding = () => {
  const { title } = useParams();
  const [data, setData] = useState<any | []>([]);
  const [activeTab, setActiveTab] = useState("about");

  useEffect(() => {
    fetch("/data/event.json")
      .then((res) => res.json())
      .then((res) => setData(res.events))
      .catch((err) => console.error("Error loading events:", err));
  }, []);

  const filterData = data.filter(
    (item: any) =>
      item.title.toLowerCase().replaceAll(" ", "-") === title?.toLowerCase()
  );

  const venueImages: string[] = [
    "https://i.ytimg.com/vi/dJVeLpNeR_8/hqdefault.jpg",
    "https://responsive.fxempire.com/v7/_fxempire_/2015/11/china-copper-forexwords.jpg?func=cover&q=70&width=700",
    "https://matcha.so/_next/image?url=https://media.matcha.so/community-logos/79771ecc-55e1-4eba-b5ec-edb204b57310.png&w=256&q=75",
    "https://encrypted-tbn3.gstatic.com/images?q=tbn:ANd9GcQp1vU3I14j2dIg-W9Tdj1n3lfwqyjuhnXMWSFwZl49zQpVMTkG",
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRfzuwVZJ84H_HNCPa5nzXgKHxJ955EtT4kiggoHg4NX_CSj-uF",
    "https://www.showsbee.com/newmaker/www/u/2023/20237/cfr_img/Immuno-Oncology-Summit.png",
    "https://media.licdn.com/dms/image/v2/D4D22AQGdZcW9pQiZoA/feedshare-shrink_800/feedshare-shrink_800/0/1705736587487?e=2147483647&v=beta&t=cTe_-jE8gYtf_GwABBLMHEtfGWn2dABIS8z3PQmRnqU",
    "https://m.media-amazon.com/images/I/81Rbyr34zmL._AC_UF1000,1000_QL80_.jpg",
  ];

  const formatDate = (dateStr: string) => {
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  };

  useEffect(() => {
    const sections = document.querySelectorAll("div[id]");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveTab(entry.target.id);
          }
        });
      },
      {
        rootMargin: "-50% 0px -50% 0px",
        threshold: 0.1,
      }
    );

    sections.forEach((section) => observer.observe(section));

    return () => {
      sections.forEach((section) => observer.unobserve(section));
    };
  }, []);

  return (
    <div className={Style.container}>
      <div
        className={Style.background}
        style={{
          backgroundImage: `url(${Img})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "250px",
        }}
      ></div>

      <div className={Style.wrapper}>
        <div className={Style.mainbox}>
          {filterData.map((item: any, index: any) => (
            <div key={item.id} className={Style.content}>
              <div className={Style.Image}>
                <img
                  src={venueImages[index % venueImages.length]}
                  alt="Venue"
                />
              </div>
              <div className={Style.Detail}>
                <h2>
                  {formatDate(item.start_date)} - {formatDate(item.end_date)}
                </h2>
                <h3>{item.title}</h3>

                <div className={Style.rating}>
                  <h2>
                    <i className="fa-solid fa-star"></i> Rating
                  </h2>
                  <h3>{item.tags[0]}</h3>
                </div>

                <div className={Style.location}>
                  <i className="fa-solid fa-location-dot"></i>
                  <h2>
                    {item.venue.address}, {item.venue.city}, {item.venue.state}
                  </h2>
                </div>

                <div className={Style.tags}>
                  {item.tags.map((tag: any, i: any) => (
                    <span key={i} className={Style.tag}>
                      #{tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className={Style.divide}>
          <div className={Style.leftSide}>
            <div className={Style.tabBar}>
              {[
                "about",
                "highlights",
                "speakers",
                "organizer",
                "venue",
                "tickets",
                "reviews",
              ].map((tab) => (
                <a
                  key={tab}
                  href={`#${tab}`}
                  className={`${Style.tabLink} ${
                    activeTab === tab ? Style.activeTab : ""
                  }`}
                >
                  {tab.charAt(0).toUpperCase() + tab.slice(1)}
                </a>
              ))}
            </div>

            <div className={Style.TabData}>
              {filterData.map((item: any) => (
                <div key={item.id} className={Style.content}>
                  <div className={Style.Detail} id="about">
                    <div className={Style.galleryGrid}>
                      {venueImages.slice(0, 3).map((src, i) => (
                        <img key={i} src={src} alt={`Gallery ${i + 1}`} />
                      ))}
                    </div>

                    <p>{item.description}</p>
                    <h3>{item.title}</h3>

                    <div className={Style.tag}>
                      <ul>
                        {item.tags.map((tag: any, i: any) => (
                          <li key={i}>{tag}</li>
                        ))}
                      </ul>
                    </div>

                    <div className={Style.location}>
                      <i className="fa-solid fa-location-dot"></i>
                      <h2>
                        {item.venue.address}, {item.venue.city},{" "}
                        {item.venue.state}
                      </h2>
                    </div>
                    <div className={Style.moreDetail}>
                      <ul>
                        <li>
                          Date
                          <span>
                            {" "}
                            {formatDate(item.start_date)} -{" "}
                            {formatDate(item.end_date)}
                          </span>
                        </li>
                        <li>
                          Category
                          <div className={Style.category}>
                            {item.categories.map((item: any) => (
                              <span>{item}</span>
                            ))}
                          </div>
                        </li>
                        <li>
                          EventType
                          <div className={Style.tag}>
                            {item.tags.map((item: any) => (
                              <span>{item}</span>
                            ))}
                          </div>
                        </li>
                        <li>
                          Official Links
                          <a href={item.website}>{item.website}</a>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className={Style.tabSection} id="highlights">
                    <h2>Highlights</h2>
                    <ul>
                      <li>Global audience</li>
                      <li>Keynote speeches</li>
                      <li>Business networking</li>
                    </ul>
                  </div>

                  <div className={Style.tabSection} id="speakers">
                    <h2>Speakers</h2>
                    <p>Dr. James Carter, Prof. Lucy Watson, etc.</p>
                  </div>
                  <div className={Style.banner}>
                    <img
                      src="https://info.dumgal.gov.uk/media/waste/LD-fluorescent-tubes-landscape.png"
                      alt=""
                    />
                  </div>
                  <div className={Style.tabSection} id="organizer">
                    <h2>Organizer</h2>
                    <div className={Style.organizerDivide}>
                      <div className={Style.organiserImage}>
                        <img
                          src="https://gravatar.com/avatar/6275bdfe1e8580055d60a85bd80c66a1?s=200"
                          alt="Organizer"
                        />
                      </div>
                      <div className={Style.organiserDetail}>
                        <p>
                          <strong>{item.organizer.name}</strong>
                        </p>
                        <p>{item.organizer.contact.designation}</p>
                        <p>{item.organizer.contact.email}</p>
                        <p>{item.organizer.contact.phone}</p>
                        <p>{item.organizer.contact.email}</p>
                        <a href={item.organizer.website}>
                          {item.organizer.website}
                        </a>
                        <p>{item.organizer.description}</p>

                        <p>
                          <span>Total Events by Organizer:</span>{" "}
                          {
                            data.filter(
                              (ev: any) =>
                                ev.organizer.name.toLowerCase() ===
                                item.organizer.name.toLowerCase()
                            ).length
                          }
                        </p>
                        <div className={Style.analyticsBox}>
                          <p>👀 Views: {item.analytics.views}</p>
                          <p>
                            📝 Registrations: {item.analytics.registrations}
                          </p>
                          <p>📈 Leads: {item.analytics.leads}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className={Style.tabSection} id="venue">
                    <h2>Venue</h2>
                    <p>
                      <i>Venue Name :</i> {item.venue.name}
                    </p>
                    <p>
                      <i>Venue Address: </i>
                      {item.venue.address}, {item.venue.city},{" "}
                      {item.venue.state}, {item.venue.postal_code}
                    </p>
                    <div
                      style={{
                        width: "100%",
                        height: "500px",
                        marginTop: "0.5rem",
                      }}
                    >
                      <iframe
                        title="map"
                        width="100%"
                        height="100%"
                        frameBorder="0"
                        style={{ border: 0, borderRadius: "10px" }}
                        src={`https://maps.google.com/maps?q=${item.venue.latitude},${item.venue.longitude}&z=15&output=embed`}
                        allowFullScreen
                      ></iframe>
                    </div>
                  </div>

                  <div className={Style.tabSection} id="tickets">
                    <h2>Tickets</h2>
                    <div className={Style.Ticket}>
                      <ul>
                        {item.ticket_prices.map((item: any) => {
                          return (
                            <li>
                              <h2>{item.type}</h2>
                              <h2>{item.price}</h2>
                              <h2>{item.currency}</h2>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                  <div className={Style.tabSection} id="reviews">
                    <h2>⭐ Reviews</h2>

                    <div className={Style.userReviews}>
                      <form className={Style.reviewForm}>
                        <label>
                          Your Name:
                          <input
                            type="text"
                            placeholder="Enter your name"
                            required
                          />
                        </label>

                        <label>
                          Rating:
                          <select>
                            <option value="5">⭐ 5 - Excellent</option>
                            <option value="4">⭐ 4 - Very Good</option>
                            <option value="3">⭐ 3 - Good</option>
                            <option value="2">⭐ 2 - Fair</option>
                            <option value="1">⭐ 1 - Poor</option>
                          </select>
                        </label>

                        <label>
                          Your Review:
                          <textarea
                            placeholder="Write your experience..."
                            required
                          />
                        </label>

                        <button type="submit">Submit Review</button>
                      </form>
                    </div>

                    <div className={Style.reviewList}>
                      <h3>Recent Reviews</h3>
                      <div className={Style.reviewCard}>
                        <p>
                          <strong>Ravi Sharma</strong> ⭐⭐⭐⭐☆
                        </p>
                        <p>
                          Great networking and very well-organized sessions!
                        </p>
                      </div>
                      <div className={Style.reviewCard}>
                        <p>
                          <strong>Emily Watson</strong> ⭐⭐⭐⭐⭐
                        </p>
                        <p>
                          One of the best academic conferences I've attended.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className={Style.rightSide}>
            {filterData.length > 0 && (
              <EventLandingRight
                relatedEvents={data.filter(
                  (ev: any) =>
                    ev.categories.some((cat: any) =>
                      filterData[0].categories.includes(cat)
                    ) ||
                    ev.tags.some((tag: any) => filterData[0].tags.includes(tag))
                )}
                currentEventId={filterData[0].id}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventLanding;
